import { gameProviderTypes } from '@configs/layout';

export const COLLECTION = {
  APP_STORE: {
    NEW_IOS: 'newapplications',
    NEW_FREE_IOS: 'newfreeapplications',
    NEW_PAID_IOS: 'newpaidapplications',
    TOP_FREE_IOS: 'topfreeapplications',
    //TOP_FREE_IPAD: 'topfreeipadapplications',
    TOP_GROSSING_IOS: 'topgrossingapplications',
    //TOP_GROSSING_IPAD: 'topgrossingipadapplications',
    TOP_PAID_IOS: 'toppaidapplications',
    //TOP_PAID_IPAD: 'toppaidipadapplications'
  },
  GOOGLE_PLAY_STORE: {
    TOP_FREE: 'TOP_FREE',
    TOP_PAID: 'TOP_PAID',
    GROSSING: 'GROSSING',
  },
};

export const CATEGORY = {
  APP_STORE: {
    BOOKS: 6018,
    BUSINESS: 6000,
    CATALOGS: 6022,
    EDUCATION: 6017,
    ENTERTAINMENT: 6016,
    FINANCE: 6015,
    FOOD_AND_DRINK: 6023,
    GAMES: 6014,
    GAMES_ACTION: 7001,
    GAMES_ADVENTURE: 7002,
    GAMES_ARCADE: 7003,
    GAMES_BOARD: 7004,
    GAMES_CARD: 7005,
    GAMES_CASINO: 7006,
    GAMES_DICE: 7007,
    GAMES_EDUCATIONAL: 7008,
    GAMES_FAMILY: 7009,
    GAMES_MUSIC: 7011,
    GAMES_PUZZLE: 7012,
    GAMES_RACING: 7013,
    GAMES_ROLE_PLAYING: 7014,
    GAMES_SIMULATION: 7015,
    GAMES_SPORTS: 7016,
    GAMES_STRATEGY: 7017,
    GAMES_TRIVIA: 7018,
    GAMES_WORD: 7019,
    HEALTH_AND_FITNESS: 6013,
    LIFESTYLE: 6012,
    MAGAZINES_AND_NEWSPAPERS: 6021,
    MAGAZINES_ARTS: 13007,
    MAGAZINES_AUTOMOTIVE: 13006,
    MAGAZINES_WEDDINGS: 13008,
    MAGAZINES_BUSINESS: 13009,
    MAGAZINES_CHILDREN: 13010,
    MAGAZINES_COMPUTER: 13011,
    MAGAZINES_FOOD: 13012,
    MAGAZINES_CRAFTS: 13013,
    MAGAZINES_ELECTRONICS: 13014,
    MAGAZINES_ENTERTAINMENT: 13015,
    MAGAZINES_FASHION: 13002,
    MAGAZINES_HEALTH: 13017,
    MAGAZINES_HISTORY: 13018,
    MAGAZINES_HOME: 13003,
    MAGAZINES_LITERARY: 13019,
    MAGAZINES_MEN: 13020,
    MAGAZINES_MOVIES_AND_MUSIC: 13021,
    MAGAZINES_POLITICS: 13001,
    MAGAZINES_OUTDOORS: 13004,
    MAGAZINES_FAMILY: 13023,
    MAGAZINES_PETS: 13024,
    MAGAZINES_PROFESSIONAL: 13025,
    MAGAZINES_REGIONAL: 13026,
    MAGAZINES_SCIENCE: 13027,
    MAGAZINES_SPORTS: 13005,
    MAGAZINES_TEENS: 13028,
    MAGAZINES_TRAVEL: 13029,
    MAGAZINES_WOMEN: 13030,
    MEDICAL: 6020,
    MUSIC: 6011,
    NAVIGATION: 6010,
    NEWS: 6009,
    PHOTO_AND_VIDEO: 6008,
    PRODUCTIVITY: 6007,
    REFERENCE: 6006,
    SHOPPING: 6024,
    SOCIAL_NETWORKING: 6005,
    SPORTS: 6004,
    TRAVEL: 6003,
    UTILITIES: 6002,
    WEATHER: 6001,
  },
  GOOGLE_PLAY_STORE: {
    APPLICATION: 'APPLICATION',
    ANDROID_WEAR: 'ANDROID_WEAR',
    ART_AND_DESIGN: 'ART_AND_DESIGN',
    AUTO_AND_VEHICLES: 'AUTO_AND_VEHICLES',
    BEAUTY: 'BEAUTY',
    BOOKS_AND_REFERENCE: 'BOOKS_AND_REFERENCE',
    BUSINESS: 'BUSINESS',
    COMICS: 'COMICS',
    COMMUNICATION: 'COMMUNICATION',
    DATING: 'DATING',
    EDUCATION: 'EDUCATION',
    ENTERTAINMENT: 'ENTERTAINMENT',
    EVENTS: 'EVENTS',
    FINANCE: 'FINANCE',
    FOOD_AND_DRINK: 'FOOD_AND_DRINK',
    HEALTH_AND_FITNESS: 'HEALTH_AND_FITNESS',
    HOUSE_AND_HOME: 'HOUSE_AND_HOME',
    LIBRARIES_AND_DEMO: 'LIBRARIES_AND_DEMO',
    LIFESTYLE: 'LIFESTYLE',
    MAPS_AND_NAVIGATION: 'MAPS_AND_NAVIGATION',
    MEDICAL: 'MEDICAL',
    MUSIC_AND_AUDIO: 'MUSIC_AND_AUDIO',
    NEWS_AND_MAGAZINES: 'NEWS_AND_MAGAZINES',
    PARENTING: 'PARENTING',
    PERSONALIZATION: 'PERSONALIZATION',
    PHOTOGRAPHY: 'PHOTOGRAPHY',
    PRODUCTIVITY: 'PRODUCTIVITY',
    SHOPPING: 'SHOPPING',
    SOCIAL: 'SOCIAL',
    SPORTS: 'SPORTS',
    TOOLS: 'TOOLS',
    TRAVEL_AND_LOCAL: 'TRAVEL_AND_LOCAL',
    VIDEO_PLAYERS: 'VIDEO_PLAYERS',
    WATCH_FACE: 'WATCH_FACE',
    WEATHER: 'WEATHER',
    GAME: 'GAME',
    GAME_ACTION: 'GAME_ACTION',
    GAME_ADVENTURE: 'GAME_ADVENTURE',
    GAME_ARCADE: 'GAME_ARCADE',
    GAME_BOARD: 'GAME_BOARD',
    GAME_CARD: 'GAME_CARD',
    GAME_CASINO: 'GAME_CASINO',
    GAME_CASUAL: 'GAME_CASUAL',
    GAME_EDUCATIONAL: 'GAME_EDUCATIONAL',
    GAME_MUSIC: 'GAME_MUSIC',
    GAME_PUZZLE: 'GAME_PUZZLE',
    GAME_RACING: 'GAME_RACING',
    GAME_ROLE_PLAYING: 'GAME_ROLE_PLAYING',
    GAME_SIMULATION: 'GAME_SIMULATION',
    GAME_SPORTS: 'GAME_SPORTS',
    GAME_STRATEGY: 'GAME_STRATEGY',
    GAME_TRIVIA: 'GAME_TRIVIA',
    GAME_WORD: 'GAME_WORD',
    FAMILY: 'FAMILY',
  },
};

export const gameFeatureInfos = {
  APP_STORE: [
    {
      title: 'IOS TOP FREE GAME',
      category: CATEGORY.APP_STORE.GAMES,
      collection: COLLECTION.APP_STORE.TOP_FREE_IOS,
      type: gameProviderTypes.AppleAppStore,
    },
    {
      title: 'IOS TOP PAID GAME',
      category: CATEGORY.APP_STORE.GAMES,
      collection: COLLECTION.APP_STORE.TOP_PAID_IOS,
      type: gameProviderTypes.AppleAppStore,
    },
    {
      title: 'IOS TOP GROSSING GAME',
      category: CATEGORY.APP_STORE.GAMES,
      collection: COLLECTION.APP_STORE.TOP_GROSSING_IOS,
      type: gameProviderTypes.AppleAppStore,
    },
    {
      title: 'IOS NEW FREE GAME',
      category: CATEGORY.APP_STORE.GAMES,
      collection: COLLECTION.APP_STORE.NEW_FREE_IOS,
      type: gameProviderTypes.AppleAppStore,
    },
    {
      title: 'IOS NEW PAID GAME',
      category: CATEGORY.APP_STORE.GAMES,
      collection: COLLECTION.APP_STORE.NEW_PAID_IOS,
      type: gameProviderTypes.AppleAppStore,
    },
  ],
  GOOGLE_STORE: [
    {
      title: 'PLAY STORE TOP FREE GAME',
      category: CATEGORY.GOOGLE_PLAY_STORE.GAME,
      collection: COLLECTION.GOOGLE_PLAY_STORE.TOP_FREE,
      type: gameProviderTypes.GooglePlayStore,
    },
    {
      title: 'PLAY STORE TOP PAID GAME',
      category: CATEGORY.GOOGLE_PLAY_STORE.GAME,
      collection: COLLECTION.GOOGLE_PLAY_STORE.TOP_PAID,
      type: gameProviderTypes.GooglePlayStore,
    },
    {
      title: 'PLAY STORE TOP GROSSING GAME',
      category: CATEGORY.GOOGLE_PLAY_STORE.GAME,
      collection: COLLECTION.GOOGLE_PLAY_STORE.GROSSING,
      type: gameProviderTypes.GooglePlayStore,
    },
  ],
};

export const appFeatureInfos = {
  APP_STORE: [
    {
      title: 'IOS TOP FREE APP',
      category: '',
      collection: COLLECTION.APP_STORE.TOP_FREE_IOS,
      type: gameProviderTypes.AppleAppStore,
    },
    {
      title: 'IOS TOP PAID APP',
      category: '',
      collection: COLLECTION.APP_STORE.TOP_PAID_IOS,
      type: gameProviderTypes.AppleAppStore,
    },
    {
      title: 'IOS TOP GROSSING APP',
      category: '',
      collection: COLLECTION.APP_STORE.TOP_GROSSING_IOS,
      type: gameProviderTypes.AppleAppStore,
    },
    {
      title: 'IOS NEW FREE APP',
      category: '',
      collection: COLLECTION.APP_STORE.NEW_FREE_IOS,
      type: gameProviderTypes.AppleAppStore,
    },
    {
      title: 'IOS NEW PAID APP',
      category: '',
      collection: COLLECTION.APP_STORE.NEW_PAID_IOS,
      type: gameProviderTypes.AppleAppStore,
    },
  ],
  GOOGLE_STORE: [
    {
      title: 'PLAY STORE TOP FREE APP',
      category: '',
      collection: COLLECTION.GOOGLE_PLAY_STORE.TOP_FREE,
      type: gameProviderTypes.GooglePlayStore,
    },
    {
      title: 'PLAY STORE TOP PAID APP',
      category: '',
      collection: COLLECTION.GOOGLE_PLAY_STORE.TOP_PAID,
      type: gameProviderTypes.GooglePlayStore,
    },
    {
      title: 'PLAY STORE TOP GROSSING APP',
      category: '',
      collection: COLLECTION.GOOGLE_PLAY_STORE.GROSSING,
      type: gameProviderTypes.GooglePlayStore,
    },
  ],
};
